import Vue from 'vue'
import Router from 'vue-router'

import Welcome from '@/components/Welcome'
import Main from '@/components/Main'
import NotFound from '@/components/NotFound'

// pages
import Home from '@/components/pages/Home'
import WhatWeDo from '@/components/pages/WhatWeDo'
import CreativeServices from '@/components/pages/CreativeServices'
import Products from '@/components/pages/Products'
import ViewOurWork from '@/components/pages/ViewOurWork'
import Estimate from '@/components/pages/Estimate'
import ContactUs from '@/components/pages/ContactUs'
import FtpUploads from '@/components/pages/FtpUploads'

// products
import GraphicPanels from '@/components/pages/products/GraphicPanels'
import Mountings from '@/components/pages/products/Mountings'
import SpecialtyItems from '@/components/pages/products/SpecialtyItems'
import RoutedPlastic from '@/components/pages/products/RoutedPlastic'
// import SiteAmenities from '@/components/pages/products/SiteAmenities'
import StoryWalk from '@/components/pages/products/StoryWalk'
import BulletinBoards from '@/components/pages/products/BulletinBoards'
import Pedestals from '@/components/pages/products/Pedestals'
import GeneralFrames from '@/components/pages/products/GeneralFrames'
import Duraframes from '@/components/pages/products/Duraframes'
import Kiosks from '@/components/pages/products/Kiosks'
import Nps from '@/components/pages/products/Nps'
import Durareaders from '@/components/pages/products/Durareaders'
import Fiberlast from '@/components/pages/products/Fiberlast'
import Novalloy from '@/components/pages/products/Novalloy'
import ImageLOC from '@/components/pages/products/ImageLOC'
import Composite from '@/components/pages/products/Composite'
import NovalloyPlus from '@/components/pages/products/NovalloyPlus'
import TruColor from '@/components/pages/products/TruColor'

// view our work
import Oregon from '@/components/pages/viewOurWork/Oregon'
import MtVernon from '@/components/pages/viewOurWork/MtVernon'
import Highway12 from '@/components/pages/viewOurWork/Highway12'
import JordanRiver from '@/components/pages/viewOurWork/JordanRiver'
import LaPetiteRoche from '@/components/pages/viewOurWork/LaPetiteRoche'
import LoganCity from '@/components/pages/viewOurWork/LoganCity'
import SeeForever from '@/components/pages/viewOurWork/SeeForever'
import SmithFarm from '@/components/pages/viewOurWork/SmithFarm'
import Watershed from '@/components/pages/viewOurWork/Watershed'
import Williamsons from '@/components/pages/viewOurWork/Williamsons'

// creative services
import ContentDevelopment from '@/components/pages/creativeServices/ContentDevelopment'
import GraphicDesign from '@/components/pages/creativeServices/GraphicDesign'
import Illustration from '@/components/pages/creativeServices/Illustration'

// what we do
import Interpretive from '@/components/pages/whatWeDo/Interpretive'
import Historical from '@/components/pages/whatWeDo/Historical'
import Commemorative from '@/components/pages/whatWeDo/Commemorative'
import Wayfinding from '@/components/pages/whatWeDo/Wayfinding'

Vue.use(Router)

export default new Router({
  mode: 'history',
  scrollBehavior (to, from, savedPosition) {
    return { x: 0, y: 0 }
  },
  routes: [
    {
      path: '/welcome',
      component: Welcome
    },
    {
      path: '/',
      redirect: '/welcome',
      name: 'main',
      component: Main,
      children: [
        {
          name: 'home',
          path: 'home',
          component: Home
        },
        {
          name: 'what-we-do',
          path: 'what-we-do',
          component: WhatWeDo
        },
        {
          name: 'creative-services',
          path: 'creative-services',
          component: CreativeServices
        },
        {
          name: 'products',
          path: 'products',
          component: Products
        },
        {
          name: 'view-our-work',
          path: 'view-our-work',
          component: ViewOurWork
        },
        {
          name: 'estimate',
          path: 'estimate',
          component: Estimate
        },
        {
          name: 'contact-us',
          path: 'contact-us',
          component: ContactUs
        },
        {
          name: 'ftp-uploads',
          path: 'ftp-uploads',
          component: FtpUploads
        },

        // Creative Services
        {
          name: 'content-development',
          path: 'creative-services/content-development',
          component: ContentDevelopment
        },
        {
          name: 'graphic-design',
          path: 'creative-services/graphic-design',
          component: GraphicDesign
        },
        {
          name: 'illustration',
          path: 'creative-services/illustration',
          component: Illustration
        },

        // Products
        {
          name: 'graphic-panels',
          path: 'products/graphic-panels',
          component: GraphicPanels
        },
        {
          name: 'mountings',
          path: 'products/mountings',
          component: Mountings
        },
        {
          name: 'specialty-items',
          path: 'products/specialty-items',
          component: SpecialtyItems
        },
        {
          name: 'story-walk',
          path: 'products/story-walk',
          component: StoryWalk
        },
        /*
        {
          name: 'site-amenities',
          path: 'products/site-amenities',
          component: SiteAmenities
        },
         */
        {
          name: 'routed-plastic',
          path: 'products/routed-plastic',
          component: RoutedPlastic
        },
        {
          name: 'bulletin-boards',
          path: 'products/mountings/bulletin-boards',
          component: BulletinBoards
        },
        {
          name: 'pedestals',
          path: 'products/mountings/pedestals',
          component: Pedestals
        },
        {
          name: 'general',
          path: 'products/mountings/general-frames',
          component: GeneralFrames
        },
        {
          name: 'duraframes',
          path: 'products/mountings/duraframes',
          component: Duraframes
        },
        {
          name: 'kiosks',
          path: 'products/mountings/kiosks-structures',
          component: Kiosks
        },
        {
          name: 'nps',
          path: 'products/mountings/nps-frames',
          component: Nps
        },
        {
          name: 'durareaders',
          path: 'products/durareaders',
          component: Durareaders
        },
        {
          name: 'fiberlast',
          path: 'products/fiberlast',
          component: Fiberlast
        },
        {
          name: 'novalloy',
          path: 'products/novalloy',
          component: Novalloy
        },
        {
          name: 'imageloc',
          path: 'products/imageloc',
          component: ImageLOC
        },
        {
          name: 'composite',
          path: 'products/digital-composite',
          component: Composite
        },
        {
          name: 'novalloyplus',
          path: 'products/novalloy-plus',
          component: NovalloyPlus
        },
        {
          name: 'trucolor',
          path: 'products/trucolor-porcelain',
          component: TruColor
        },

        // View our work
        {
          name: 'oregon',
          path: 'view-our-work/oregon-islands-nwr',
          component: Oregon
        },
        {
          name: 'mtvernon',
          path: 'view-our-work/mt-vernon',
          component: MtVernon
        },
        {
          name: 'highway12',
          path: 'view-our-work/highway-12',
          component: Highway12
        },
        {
          name: 'jordanriver',
          path: 'view-our-work/jordan-river',
          component: JordanRiver
        },
        {
          name: 'lapetiteroche',
          path: 'view-our-work/la-petite-roche',
          component: LaPetiteRoche
        },
        {
          name: 'logancity',
          path: 'view-our-work/logan-city',
          component: LoganCity
        },
        {
          name: 'seeforever',
          path: 'view-our-work/see-forever-village',
          component: SeeForever
        },
        {
          name: 'smithfarm',
          path: 'view-our-work/smith-farm',
          component: SmithFarm
        },
        {
          name: 'watershed',
          path: 'view-our-work/slc-watershed',
          component: Watershed
        },
        {
          name: 'williamsons',
          path: 'view-our-work/williamsons-battlefield',
          component: Williamsons
        },

        // What we do
        {
          name: 'interpretive',
          path: 'what-we-do/interpretive',
          component: Interpretive
        },
        {
          name: 'historical',
          path: 'what-we-do/historical',
          component: Historical
        },
        {
          name: 'commemorative',
          path: 'what-we-do/commemorative',
          component: Commemorative
        },
        {
          name: 'wayfinding',
          path: 'what-we-do/identification-wayfinding',
          component: Wayfinding
        }
      ]
    },
    {
      path: '*',
      component: NotFound
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js